import type { IEvent } from './interfaces';
import type { TCalendarColorBy, TEventColor } from './types';

const SERVICE_COLORS: TEventColor[] = [
  'blue',
  'green',
  'purple',
  'orange',
  'red',
  'yellow',
];

/** Display-only: never replace the event's saved color when changing grouping. */
export function getCalendarEventColor(
  event: IEvent,
  colorBy: TCalendarColorBy = 'team-member'
): TEventColor {
  const type = event.metadata?.type;
  if (colorBy === 'service' && (!type || type === 'appointment')) {
    const serviceId = event.metadata?.serviceId;
    if (typeof serviceId !== 'string' || !serviceId.trim()) return 'gray';
    let hash = 0;
    for (const character of serviceId) {
      hash = (Math.imul(hash, 31) + character.charCodeAt(0)) | 0;
    }
    return SERVICE_COLORS[(hash >>> 0) % SERVICE_COLORS.length];
  }
  if (type === 'unavailability') return event.user?.color ?? 'gray';
  return event.user?.color ?? event.color;
}

export const pastelEventColors: Record<TEventColor, string> = {
  blue: 'border-blue-300 bg-blue-200 text-blue-950 dark:border-blue-700 dark:bg-blue-900 dark:text-blue-100',
  green:
    'border-green-300 bg-green-200 text-green-950 dark:border-green-700 dark:bg-green-900 dark:text-green-100',
  red: 'border-red-300 bg-red-200 text-red-950 dark:border-red-700 dark:bg-red-900 dark:text-red-100',
  yellow:
    'border-yellow-300 bg-yellow-100 text-yellow-950 dark:border-yellow-700 dark:bg-yellow-900 dark:text-yellow-100',
  purple:
    'border-purple-300 bg-purple-200 text-purple-950 dark:border-purple-700 dark:bg-purple-900 dark:text-purple-100',
  orange:
    'border-orange-300 bg-orange-200 text-orange-950 dark:border-orange-700 dark:bg-orange-900 dark:text-orange-100',
  gray: 'border-neutral-300 bg-neutral-200 text-neutral-900 dark:border-neutral-600 dark:bg-neutral-800 dark:text-neutral-100',
};
